module.exports = __webpack_public_path__ + "static/img/esales-4.aa4360c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zsy_esales/esales-4.png
// module id = 242
// module chunks = 6